/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */

export class MouseState {
  public x = 0;
  public y = 0;
  public buttonMask = 0;

  setPosition(x: number, y: number): void {
    this.x = x;
    this.y = y;
  }

  updateButtonState(buttonIndex: number, isPressed: boolean): void {
    const buttonBit = 1 << buttonIndex;
    if (isPressed) {
      this.buttonMask |= buttonBit;
    } else {
      this.buttonMask &= ~buttonBit;
    }
  }
}
